<google-map [height]="height"
  [width]="width"
  [center]="center"
  [zoom]="zoom"
  [options]="mapOptions"
  >
  <map-polyline [options]="pathPolylineOptions" [path]="vertices"></map-polyline>
  @for (trail of trails; track $index) {
    <map-polyline [path]="trail.path" [options]="trail.options"></map-polyline>
  }
  @if (zones) {
    @if (zones.whiteRadiusMeters) {
      <map-circle
        [center]="zones.center"
        [radius]="zones.whiteRadiusMeters"
        [options]="whiteZoneCircleOptions"
        ></map-circle>
    }
    <map-circle
      [center]="zones.center"
      [radius]="zones.yellowRadiusMeters"
      [options]="yellowZoneCircleOptions"
      ></map-circle>
    <map-circle
      [center]="zones.center"
      [radius]="zones.redRadiusMeters"
      [options]="redZoneCircleOptions"
      ></map-circle>
  }
  @for (marker of markers; track $index) {
    <map-marker
      [position]="marker.position"
      [icon]="marker.icon"
      [options]="marker.options"
      (mapDragend)="onMarkerDragEnd($event, marker)"
      >
    </map-marker>
  }
  @for (arrow of arrows; track arrow.id) {
    <map-polyline [path]="arrow.path" [options]="arrow.casingOptions"></map-polyline>
    <map-polyline [path]="arrow.path" [options]="arrow.lineOptions"></map-polyline>
  }
</google-map>
